module.exports = __webpack_public_path__ + "img/calculator_image.8aaeb7f4.svg";